import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material'

import { BbLogoIcon } from 'components/Custom/IconesSVG'

import useTextStyles from 'styles/useTextStyles'

interface DialogMessageAlertProps {
  title?: string
  message: string | JSX.Element
  isDialogOpen: boolean
  handleCloseDialog: () => void
  butonName1: string
  buttonName2?: string
  onClickButton1: () => void
  onClickButton2?: () => void
}

export const DialogMessageAlert = ({
  title,
  message,
  isDialogOpen,
  handleCloseDialog,
  butonName1,
  buttonName2,
  onClickButton1,
  onClickButton2
}: DialogMessageAlertProps) => {
  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleCloseDialog}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '320px'
        }
      }}
    >
      <DialogTitle align="center">
        <Box className="w-full flex justify-center mb-5">
          <BbLogoIcon colors="#625B71" />
        </Box>
        {title}
      </DialogTitle>
      <DialogContent>
        <Box>
          <DialogContentText
            sx={{ ...useTextStyles.bodyMedium }}
            aria-label={typeof message === 'string' ? message : 'Mensagem de dialogo'}
          >
            {message}
          </DialogContentText>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          title={butonName1 || ''}
          onClick={() => onClickButton1()}
          color="primary"
          sx={{ ...useTextStyles.labelLarge, textTransform: 'none' }}
        >
          {butonName1}
        </Button>
        {buttonName2 && onClickButton2 && (
          <Button
            title={buttonName2 || ''}
            onClick={() => onClickButton2()}
            color="primary"
            sx={{ ...useTextStyles.labelLarge, textTransform: 'none' }}
          >
            {buttonName2}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default DialogMessageAlert
